import { App, URLOpenListenerEvent } from '@capacitor/app';
import { PluginListenerHandle } from '@capacitor/core';
import VueRouter, { RawLocation } from 'vue-router'
import { RouteNames } from './routes';

export default class UniversalLinkRouter {

    static AddAppUrlOpenListener(vueRouter: VueRouter) : PluginListenerHandle {
        return App.addListener('appUrlOpen', (data: URLOpenListenerEvent) => {
            UniversalLinkRouter.AppUrlOpenCallback(data, vueRouter);
        })
    }

    static AppUrlOpenCallback(data: URLOpenListenerEvent, vueRouter: VueRouter) {
        if (data && data.url) {
            UniversalLinkRouter.RouteToLinkUrl(data.url, vueRouter);
        }
    }

    private static RouteToLinkUrl(url: string, vueRouter: VueRouter) {
        const path = UniversalLinkRouter.GetPath(url);;

        const urlParams = UniversalLinkRouter.GetQueryParams(url);;

        if (path.startsWith('/confirm-email')) {
            void vueRouter.push({ name: RouteNames.ConfirmEmail, query: { code: urlParams.get('code'), id: urlParams.get('id'), companytype: urlParams.get('companytype')} });

        } else if (path.startsWith('/register')) {
            const route: RawLocation = urlParams.get('code')
                ? { name: RouteNames.Register, query: { code: urlParams.get('code'), id: urlParams.get('id'), email: urlParams.get('email') } }
                : { name: RouteNames.Register }

            void vueRouter.push(route);

        } else if (path.startsWith('/reset-password')) {
            void vueRouter.push({ name: RouteNames.ResetPassword, query: { email: urlParams.get('email'), token: urlParams.get('token') } });

        }
    }

    private static GetPath(url: string): string {
        const hashPosition = url.indexOf('#');

        return hashPosition > -1
            ? url.substring(hashPosition + 1)
            : '';
    }

    private static GetQueryParams(url: string): URLSearchParams {
        const paramsPosition = url.indexOf('?');

        return paramsPosition > -1
            ? new URLSearchParams(url.substring(paramsPosition + 1))
            : new URLSearchParams();
    }
}